import _objectSpread from '@babel/runtime-corejs3/helpers/esm/objectSpread2';

var scrollToElement = function scrollToElement(container, element, direction) {
  if (!container || !element || !('current' in container) || !('current' in element)) return;
  var containerElement = container.current;
  var targetElement = element.current;
  if (!containerElement || !targetElement) return;
  var containerRect = containerElement.getBoundingClientRect();
  var elementRect = targetElement.getBoundingClientRect();
  var scrollOptions = {
    behavior: 'smooth'
  };
  if (direction === 'vertical') {
    containerElement.scrollTo(_objectSpread({
      top: elementRect.top - containerRect.top + containerElement.scrollTop - containerRect.height / 2 + elementRect.height / 2
    }, scrollOptions));
  } else {
    containerElement.scrollTo(_objectSpread({
      left: elementRect.left - containerRect.left + containerElement.scrollLeft - containerRect.width / 2 + elementRect.width / 2
    }, scrollOptions));
  }
};

export { scrollToElement };
//# sourceMappingURL=useScrollToItem.js.map
